import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {navigator, router} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';
import deepEqual from 'deep-equal';

import store from '../../store';
import style from '../../../../scss/accountList.scss';
import listStyle from '../../../../scss/list.scss';

import {
	selectAccountsQuery,
	selectLanguage
} from '../../selectors';
import getRoutes from '../../routes';
import down from '../../icons/down';
import up from '../../icons/up';
import {
	fetchAccounts,
	fetchAllowedAccounts,
	fetchInvitedAccounts,
	selectAllAccounts, selectAllAllowedAccounts,
	selectAllInvitedAccounts
} from '../../slices/accountSlice';

@customElement('arc-account-list')
export class AccountList extends connect(store)(router(navigator(LitElement))) {
	static styles = [listStyle, style];

	static properties = {
		listType: {type: String}, // type of account list to show: all, invited, allowed
		showSearch: {type: Boolean},
		showFilter: {type: Boolean},
	};

	constructor() {
		super();
		this.currentLanguage = 'de';
		this.accounts = [];
		this.listType = 'all';
		this.showSearch = true;
		this.showFilter = true;
		//this.searchText = '';
		//this.filtersVisible = false;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = selectLanguage(state);
		this.accounts = selectAllAccounts(state);
		switch (this.listType) {
			case 'all':
				this.accounts = selectAllAccounts(state);
				break;
			case 'invited':
				this.accounts = selectAllInvitedAccounts(state);
				break;
			case 'allowed':
				this.accounts = selectAllAllowedAccounts(state);
				break;
		}
		this.accountsQuery = selectAccountsQuery(state);

		if (this.updateNeeded) {
			this.updateNeeded = false;
			switch (this.listType) {
				case 'all':
					store.dispatch(fetchAccounts({...this.query}));
					break;
				case 'invited':
					store.dispatch(fetchInvitedAccounts({...this.query}));
					break;
				case 'allowed':
					store.dispatch(fetchAllowedAccounts({profileId: this.profileId, ...this.query}));
					break;
			}
		}
		this.requestUpdate();
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {

		// do accounts need update from backend
		this.updateNeeded = (route === 'admin-accounts' || route === 'artist-share') &&
			(!deepEqual(this.query, query) || this.profileId !== params.id);

		this.profileId = params.id;
		this.params = params;
		this.query = query;
		this.data = data;
	}

	connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	updateSearch(event) {
		this.searchText = event.target.value.trim().toLowerCase();
	}

	getOrderQuery(orderBy) {
		return {
			...this.query,
			...{
				orderBy: orderBy,
				orderByDirection: this.accountsQuery.orderByDirection === 'desc' ? 'asc' : 'desc'
			}
		};
	}

	getOrderDirectionIcon(orderBy) {
		if (this.query.orderBy === orderBy) {
			return this.accountsQuery.orderByDirection === 'asc' ? down : up;
		} else {
			return '';
		}
	}

	render() {
		return html`
			<arc-account-list-filter class="accountListFilter" .showSearch="${this.showSearch}" .showFilter="${this.showFilter}"></arc-account-list-filter>

			<div class="list accountList">
				${this.accounts.length > 0
					? html`
						<div class="listHeader">
							<div>
								<arc-routerlink .route="admin-accounts" .query=${this.getOrderQuery('role')}>
									${msg('Role')} ${this.getOrderDirectionIcon('role')}
								</arc-routerlink>
							</div>
							<div>${msg('Name')}</div>
							<div>${msg('eMail')}</div>
							<div>${msg('enabled')}</div>
							<div>${msg('test')}</div>
							<div>${msg('has logged in')}</div>
							<div>${msg('invited by')}</div>
							<div>${msg('Association')}</div>
						</div>

						${repeat(
							this.accounts,
							(account) => account.id,
							(account, index) => html`
								<div><arc-account-list-item .account=${account}></arc-account-list-item></div>
							`
						)}
					`
					: html` <p class="emptyMessage">${msg('No users invited.')}</p> `}
			</div>
		`;
	}
}
